[
  {
    "value": "KKT",
    "label": "쿵쿵따 전용 단어",
    "lang": [
      "ko", "en"
    ]
  },
  {
    "value": "HBW",
    "label": "어인정 한방 방어 단어",
    "lang": [
      "ko", "en"
    ]
  },
  {
    "value": "SBW",
    "label": "안전 입력 제한 단어",
    "lang": [
      "ko", "en"
    ]
  },
  {
    "value": "DDW",
    "label": "단어 대결 전용 단어",
    "lang": [
      "ko", "en"
    ]
  },
  {
    "value": "ODW",
    "label": "우리말샘",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "EMW",
    "label": "매너 테이블 제외 단어",
    "lang": [
      "ko", "en"
    ]
  },
  {
    "value": "IMS",
    "label": "THEIDOLM@STER",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "VOC",
    "label": "음성합성엔진",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "KRR",
    "label": "개구리중사케로로",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "KTV",
    "label": "국내방송프로그램",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "KOT",
    "label": "대한민국철도역",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "DOT",
    "label": "도타2",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "CON",
    "label": "콘솔 게임",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "BRD",
    "label": "브랜드/회사",
    "lang": [
      "ko", "en"
    ]
  },
  {
    "value": "HRT",
    "label": "국가유산",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "THP",
    "label": "동방프로젝트",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "DRR",
    "label": "듀라라라!!",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "DGM",
    "label": "디지몬",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "RAG",
    "label": "음식물/식료품",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "LVL",
    "label": "러브라이브!",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "LOL",
    "label": "리그오브레전드",
    "lang": [
      "ko", "en"
    ]
  },
  {
    "value": "MRN",
    "label": "마법소녀리리컬나노하",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "MMM",
    "label": "마법소녀마도카☆마기카",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "MAP",
    "label": "메이플스토리",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "MOB",
    "label": "모바일게임",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "CYP",
    "label": "사이퍼즈",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "STA",
    "label": "스타크래프트",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "OIJ",
    "label": "신조어/밈/속어/용어/유행어/명대사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "KGR",
    "label": "아지랑이프로젝트",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "ELW",
    "label": "엘소드",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "OVW",
    "label": "오버워치",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "NEX",
    "label": "온라인게임",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "MOV",
    "label": "영화",
    "lang": [
      "ko",
      "en"
    ]
  },
  {
    "value": "WOW",
    "label": "월드오브워크래프트",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "KPO",
    "label": "유명인",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "JLN",
    "label": "라이트노벨",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "JAN",
    "label": "만화/애니메이션/웹툰",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "ZEL",
    "label": "젤다의전설",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "POK",
    "label": "포켓몬스터",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "HSS",
    "label": "하스스톤",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "HDC",
    "label": "함대컬렉션",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "HOS",
    "label": "히어로즈오브더스톰",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "BUS",
    "label": "버스정류장",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "BDM",
    "label": "BangDream!",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "KIO",
    "label": "끄투리오",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "SFX",
    "label": "특수촬영물",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "NFM",
    "label": "소설/시/수필/동화",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "WZW",
    "label": "위저딩월드",
    "lang": [
      "ko", "en"
    ]
  },
  {
    "value": "OJU",
    "label": "100%OrangeJuice",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "CKR",
    "label": "쿠키런",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "MCR",
    "label": "마인크래프트",
    "lang": [
      "ko", "en"
    ]
  },
  {
    "value": "MMB",
    "label": "모두의마블",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "HSR",
    "label": "붕괴: 스타레일",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "E2R",
    "label": "EZ2ONREBOOTR",
    "lang": [
      "en"
    ]
  },
  {
    "value": "BOG",
    "label": "보드게임",
    "lang": [
      "ko", "en"
    ]
  },
  {
    "value": "YGO",
    "label": "유희왕",
    "lang": [
      "ko", "en"
    ]
  },
  {
    "value": "e03",
    "label": "★",
    "lang": [
      "en"
    ]
  },
  {
    "value": "e05",
    "label": "동물",
    "lang": [
      "en"
    ]
  },
  {
    "value": "e08",
    "label": "인체",
    "lang": [
      "en"
    ]
  },
  {
    "value": "e12",
    "label": "감정",
    "lang": [
      "en"
    ]
  },
  {
    "value": "e13",
    "label": "음식",
    "lang": [
      "en"
    ]
  },
  {
    "value": "e15",
    "label": "지명",
    "lang": [
      "en"
    ]
  },
  {
    "value": "e18",
    "label": "사람",
    "lang": [
      "en"
    ]
  },
  {
    "value": "e20",
    "label": "식물",
    "lang": [
      "en"
    ]
  },
  {
    "value": "e43",
    "label": "날씨",
    "lang": [
      "en"
    ]
  },
  {
    "value": "0",
    "label": "주제없음",
    "lang": [
      "ko", "en"
    ]
  },
  {
    "value": "10",
    "label": "가톨릭",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "20",
    "label": "건설",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "30",
    "label": "경제",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "40",
    "label": "고적",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "50",
    "label": "고유",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "60",
    "label": "공업",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "70",
    "label": "광업",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "80",
    "label": "교육",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "90",
    "label": "교통",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "100",
    "label": "군사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "110",
    "label": "기계",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "120",
    "label": "기독교",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "130",
    "label": "논리",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "140",
    "label": "농업",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "150",
    "label": "문학",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "160",
    "label": "물리",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "170",
    "label": "미술",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "180",
    "label": "민속",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "190",
    "label": "동물",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "200",
    "label": "법률",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "210",
    "label": "불교",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "220",
    "label": "사회",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "230",
    "label": "생물",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "240",
    "label": "수학",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "250",
    "label": "수산",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "260",
    "label": "수공",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "270",
    "label": "식물",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "280",
    "label": "심리",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "290",
    "label": "약학",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "300",
    "label": "언론",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "310",
    "label": "언어",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "320",
    "label": "역사",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "330",
    "label": "연영",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "340",
    "label": "예술",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "350",
    "label": "운동",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "360",
    "label": "음악",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "370",
    "label": "의학",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "380",
    "label": "인명",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "390",
    "label": "전기",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "400",
    "label": "정치",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "410",
    "label": "종교",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "420",
    "label": "지리",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "430",
    "label": "지명",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "440",
    "label": "책명",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "450",
    "label": "천문",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "460",
    "label": "철학",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "470",
    "label": "출판",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "480",
    "label": "통신",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "490",
    "label": "컴퓨터",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "500",
    "label": "한의학",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "510",
    "label": "항공",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "520",
    "label": "해양",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "530",
    "label": "화학",
    "lang": [
      "ko"
    ]
  },
  {
    "value": "e53",
    "label": "화학",
    "lang": [
      "en"
    ]
  },
  {
    "value": "1001",
    "label": "나라이름과수도",
    "lang": [
      "ko"
    ]
  }
]
